import { createApiCall } from 'lib/base';

const FETCH_INVESTMENT_EDIT_API_ID = 'INVESTCORE/FETCH_INVESTMENT_EDIT_API';

const apiCall = createApiCall(
  FETCH_INVESTMENT_EDIT_API_ID,
  ({ id, payload }) => ({
    endpoint: `/api/admin/employee-investment-details/${id}`,
    method: 'PUT',
    body: payload,
    notify: true,
  })
);

export default apiCall;
